var map = {
	"./15_happy.mp3": "b272",
	"./16_sad.mp3": "78df",
	"./17_calm.mp3": "2daf",
	"./18_angry.mp3": "b5de",
	"./M_Brilliant.mp3": "b533",
	"./M_Excellent.mp3": "476d",
	"./M_Fantastic.mp3": "1751",
	"./M_Great.mp3": "cf74",
	"./M_Perfect.mp3": "ac95",
	"./M_Think again.mp3": "6274",
	"./M_Try again.mp3": "0de6",
	"./M_Very good.mp3": "d6fb",
	"./M_Well done.mp3": "0eaf",
	"./M_Work harder.mp3": "27bfe",
	"./click.mp3": "89c4",
	"./empty_true.mp3": "05e8",
	"./false.mp3": "f39d",
	"./true.mp3": "4bd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c59";